import React, { useEffect, useState } from "react";
import { getDataDeletionStatus } from "../../helper";

export default function DeletionStatus(props) {
  const [result, setResult] = useState(null);
  useEffect(() => {
    if (!result) {
      const { id } = props.match.params;
      id &&
        getDataDeletionStatus(id)
          .then((result) => setResult(result))
          .catch((error) => console.log(error));
    }
  });

  return (
    <div className="h-100 w-100 d-flex justify-content-center align-items-center">
      {result
        ? `Data deletion status for Deletion Request Id: ${result.data_deletion_id} is: ${result.cognito_status}`
        : "Loading"}
    </div>
  );
}
